import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type OrgListViewMode = 'cards' | 'list';

export const ORG_LIST_VIEW_STORAGE_KEY = 'orgListView';

/**
 * Cards or a compact list for the org dashboard's list dialogs (ISS-023). One choice, remembered
 * per browser and shared by every list; cards are the default.
 */
@Injectable({ providedIn: 'root' })
export class OrgListViewService {
    private readonly modeSubject = new BehaviorSubject<OrgListViewMode>(readStored());
    public readonly mode$ = this.modeSubject.asObservable();

    public get mode(): OrgListViewMode {
        return this.modeSubject.value;
    }

    public set(mode: OrgListViewMode): void {
        this.modeSubject.next(mode);
        try {
            localStorage.setItem(ORG_LIST_VIEW_STORAGE_KEY, mode);
        } catch {
            // private window / blocked storage: the choice just isn't remembered
        }
    }
}

function readStored(): OrgListViewMode {
    try {
        return localStorage.getItem(ORG_LIST_VIEW_STORAGE_KEY) === 'list' ? 'list' : 'cards';
    } catch {
        return 'cards';
    }
}
